query ChatMessages(
  $page: Int
  $rowsPerPage: Int
  $filter: ChatMessagesFilterInput
) {
  chatMessages(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      messageType
      message
      createdAt
      userId
      userDisplayName
      user {
        id
        email
        displayName
      }
      contentId
      content {
        id
        title
      }
    }
  }
}
